/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {AvalancheParsedInitData} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheParsedServerData";
import {GGServerDataParser} from "../GGServerDataParser";
import {IGGInitData, ITopTrain, IXBomb} from "./IGGServerData";
import {GGGameMode} from "../../gamemode/GGGameMode";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class GGParsedInitData extends AvalancheParsedInitData {

    private readonly _numScattersEnterFS:number;
    public get numScattersEnterFS():number {
        return this._numScattersEnterFS;
    }

    private readonly _wasFeatureBuy :boolean;
    public get wasFeatureBuy():boolean {
        return this._wasFeatureBuy;
    }

    private _doubleBombSpins:number;
    public get doubleBombSpins():number {
        return this._doubleBombSpins;
    }

    private _isBombSpinRestore:boolean;
    public get isBombSpinRestore():boolean {
        return this._isBombSpinRestore;
    }

    private _gameAreaSize:number;
    public get gameAreaSize():number {
        return this._gameAreaSize;
    }

    private _totalNumberOfWays:number;
    public get totalNumberOfWays():number {
        return this._totalNumberOfWays;
    }

    private readonly _xBombs:IXBomb;
    public get xBombs():IXBomb {
        return this._xBombs;
    }

    private readonly _isFreespinRestore:boolean;
    public get isFreespinRestore():boolean {
        return this._isFreespinRestore;
    }

    private _topTrain:ITopTrain;
    public get topTrain():ITopTrain {
        return this._topTrain;
    }

    private readonly _roundType:number;
    public get roundType():number {
        return this._roundType;
    }

    private readonly _bombGuarantee:boolean;
    public get bombGuarantee():boolean {
        return this._bombGuarantee;
    }

    private readonly _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];
    public get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    constructor(rawData:IGGInitData, dataParser:GGServerDataParser) {
        super(rawData, dataParser);
        this._gameAreaSize = rawData.gameAreaSize;
        this._xBombs = rawData.xBombs;
        this._isBombSpinRestore = rawData.wasFeatureBuy && (rawData.mode === GGGameMode.DOUBLE_BOMB ||rawData.mode === GameMode.NORMAL_AVALANCHE);
        this._isFreespinRestore = rawData.mode.indexOf("FREESPIN")>-1 && rawData.isRestoreState;
        this._totalNumberOfWays = rawData.totalNumberOfWays;
        this._topTrain = rawData.topTrain;
        this._roundType = rawData.roundType;
        this._bombGuarantee = rawData.bombGuarantee;
        this._doubleBombSpins = rawData.doubleBombSpins;
        this._wasFeatureBuy = rawData.wasFeatureBuy;
        this._numScattersEnterFS = rawData.freespinsLeft! + rawData.numberOfFreespinsPlayed!;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }
}